import { useSuspenseQuery } from '@tanstack/react-query';
import { reviewsService } from 'shared/src/api';
import { queryKey } from '../../../../../constant/queryKey';

export const useReviewCodiGoods = (reviewSno: number) => {
  return useSuspenseQuery({
    queryKey: queryKey.reviewCodiGoods(reviewSno),
    queryFn: () => reviewsService.getReviewCodiGoods(reviewSno),
  });
};
